import React from 'react'
import { Grid, InputLabel, Tooltip } from '@material-ui/core'
import { Button } from '@refera/ui-web'
import { TextInput } from '_/views/budget-view-v2/components/Inputs/TextInput'
import { AutocompleteV2 } from '_/components/autocomplete-v2'
import IconButton from '_/components/svg/icon-button'
import { Trash } from '@refera/ui-icons'
import { useFormContext, useFieldArray, useWatch, Controller } from 'react-hook-form'
import { FormHelperText } from '@mui/material'

import useStyles from './styles'

const HEADERS_LIST = [
  { label: 'Authorization', value: 'Authorization' },
  { label: 'Proxy-Authorization', value: 'Proxy-Authorization' },
  { label: 'WWW-Authenticate', value: 'WWW-Authenticate' },
  { label: 'X-API-Key', value: 'X-API-Key' },
  { label: 'X-Auth-Token', value: 'X-Auth-Token' },
]

export function HeaderTable() {
  const styles = useStyles()
  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext()

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'headers',
  })

  const rowValues = useWatch({ name: 'headers' })

  return (
    <Grid>
      <InputLabel variant="body2" className={styles.label}>
        Headers
      </InputLabel>
      {fields?.map((item, index) => (
        <Grid key={item?.id} className={styles.row}>
          <Grid className={styles.fullWidth}>
            <Controller
              name={`headers.${index}.key`}
              rules={{
                validate: value => {
                  const hasValue = !!watch(`headers.${index}.value`)
                  if (hasValue && !value?.label) {
                    return 'Esse campo é obrigatório'
                  }
                  return true
                },
              }}
              control={control}
              defaultValue={rowValues?.[index]?.key || null}
              render={({ value, onChange, onBlur, ref }) => (
                <AutocompleteV2
                  value={value?.label ? value : null}
                  onChange={onChange}
                  onBlur={onBlur}
                  inputRef={ref}
                  options={HEADERS_LIST}
                  placeholder="Chave"
                  className={styles.compactAutocomplete}
                  error={errors?.headers?.[index]?.key?.message}
                />
              )}
            />
          </Grid>
          <Grid className={styles.fullWidth}>
            <TextInput
              name={`headers.${index}.value`}
              rules={{
                validate: value => {
                  const hasKey = !!watch(`headers.${index}.key`)?.label
                  if (hasKey && !value?.trim()) {
                    return 'Esse campo é obrigatório'
                  }
                  return true
                },
              }}
              placeholder="Valor"
              rows={1}
              defaultValue={rowValues?.[index]?.value || ''}
              error={errors?.headers?.[index]?.value?.message}
            />
            {errors?.headers?.[index]?.value?.message && (
              <FormHelperText error>{errors?.headers?.[index]?.value?.message}</FormHelperText>
            )}
          </Grid>

          <Tooltip
            title="Excluir header"
            placement="top"
            className={styles.removeButton}
            onClick={() => remove(index)}
          >
            <IconButton variant="ghost">
              <Trash color="red" fontSize={38} />
            </IconButton>
          </Tooltip>
        </Grid>
      ))}

      <Button
        variant="secondary"
        style={{ width: '160px', marginTop: '8px' }}
        onClick={() => append({ key: null, value: '' })}
      >
        + Adicionar item
      </Button>
    </Grid>
  )
}
